import { jsx } from "react/jsx-runtime";
import PersonIcon from "@mui/icons-material/Person";
import { validateTidalLicense } from "../../base/index.js";
function Person(props) {
  return /* @__PURE__ */ jsx(
    PersonIcon,
    {
      "data-testid": "Person",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Person",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
Person.tidalIconMeta = {
  categories: "people,persona",
  name: "Person"
};
validateTidalLicense();
export {
  Person
};
//# sourceMappingURL=Person.js.map
